import { date, resource } from "./app";
import { multiple } from "../utils";

export var event = ev => {
  return new Promise(resolve => {
    resource(ev).then(res => {
      var event = res;
      event.id = ev.id;
      event.title = ev.title;
      event.allDay = ev.all_day;
      event.url = ev.url;
      event.rendering = ev.rendering;
      event.abstract = ev.short_description;
      event.description = ev.long_description;
      event.image = ev.image;
      event.occurrence = ev.occurrence;
      event.lastOccurrence = ev.last_occurrence;
      event.cancelled = !!ev.deleted_at; // Useless. Should use "deletion"
      // Change color if it is the last / before last occurrence of a session
      if (
        event.occurrence !== 0 &&
        event.occurrence >= event.lastOccurrence - 1
      ) {
        event.color = "#edab12";
      }
      // A cancelled event should appear red
      if (event.cancelled) {
        event.color = "#ed1c24";
      }

      // Adapt dates, then resolve
      event.end = null;
      Promise.all([
        date(ev.start),
        ev.end ? date(ev.end) : Promise.resolve("")
      ]).then(values => {
        event.start = values[0];
        event.end = values[1];
        resolve(event);
      });
    });
  });
};

export var participation = pt => {
  return new Promise(resolve => {
    resolve({
      id: pt.id,
      userId: pt.user_id,
      eventId: pt.event_id,
      reason: pt.reason ? pt.reason : null,
      notice: pt.notice ? pt.notice : null
    });
  });
};

export var participant = pt => {
  return new Promise(resolve => {
    resolve({
      id: pt.id,
      firstname: pt.firstname,
      lastname: pt.lastname,
      email: pt.email,
      role: pt.role,
      reason: pt.pivot.reason ? pt.pivot.reason : null,
      notice: pt.pivot.notice ? pt.pivot.notice : null
    });
  });
};

export var session = sn => {
  return new Promise(resolve => {
    resource(sn).then(res => {
      var session = res;
      session.id = sn.id;
      session.code = sn.code;
      session.description = sn.description;
      session.size = sn.size;
      // Adapt the events and resolve
      events(sn.events).then(res => {
        session.events = res;
        resolve(session);
      });
    });
  });
};

export var events = list => {
  return multiple(list, event);
};

export var participations = list => {
  return multiple(list, participation);
};

export var participants = list => {
  return multiple(list, participant);
};

export var sessions = list => {
  return multiple(list, session);
};

const adapters = {
  event,
  events,
  participation,
  participations,
  participant,
  participants,
  session,
  sessions
};

export default adapters;
